module.exports = __webpack_public_path__ + "img/maestro.ce0e1d8e.svg";